import { render } from "./CostByProjectChart.vue?vue&type=template&id=176e1fbe"
import script from "./CostByProjectChart.vue?vue&type=script&lang=js"
export * from "./CostByProjectChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__